import { render, staticRenderFns } from "./classicHomeDetail.vue?vue&type=template&id=b7781d88&scoped=true"
import script from "./classicHomeDetail.vue?vue&type=script&lang=js"
export * from "./classicHomeDetail.vue?vue&type=script&lang=js"
import style0 from "./classicHomeDetail.vue?vue&type=style&index=0&id=b7781d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7781d88",
  null
  
)

export default component.exports